// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"c89a6c89","113":"1bce7f2f","234":"b62bcffa","272":"88a5e5e8","438":"654cd94f","534":"4a08573d","676":"725288a5","701":"e79a279f","785":"cda48578","862":"dbb0bf2e","925":"22615921"}[chunkId] + ".chunk.js";
};